export class Salutation {
    code: string;
    name: string;
    // gender: string;
}


// WEBPACK FOOTER //
// ./src/app/models/salutation.ts